import '../styles/components/ProductCard.scss'
import { useNavigate } from 'react-router-dom'
import { useCart } from '../contexts/CartContext';
import { SERVER } from '../hooks/config';
import { useState } from 'react';
import Modal from './Modal';

const ProductCard = ({ product }) => {
    const navigate = useNavigate()
    const { addToCart } = useCart();
    const [showModal, setShowModal] = useState(false);
    
    const handleAddToCart = (e) => {
        e.stopPropagation()
        addToCart(product, 1);
        setShowModal(true);
    };

    const id = product.id
    
    return(
        <>
            <div className="ProductCard" onClick={() => navigate(`/Products/${product.name}`, { state: { id } })}>
                <div className='image-container'>
                    <img src={SERVER+product.banner} alt={product.name} />
                    <div className='badge-container'>
                        {product.promotion > 0 && (
                            <div className='promotion-percentage'>
                                {Math.round(product.promotion)}%
                            </div>
                        )}
                        {product.new_product && product.promotion <= 0 && (
                            <div className='new-product'>
                                NEW
                            </div>
                        )}
                    </div>
                </div>
                <div className='product-details'>
                    <span className='product-name'> {product.name} </span>
                    {product.promotion > 0 ? (
                        <div className='price-after-promotion'>
                            <span className='old-price'> {product.price} DT </span>
                            <span className='actual-price'> {product.price - (product.price * product.promotion / 100)} DT </span>
                        </div>
                    ) : (
                        <span className='product-price'> {product.price} DT </span>
                    )}
                </div>
                <button onClick={handleAddToCart}> Ajouter au panier </button>
            </div>

            {/* Success Modal */}
            <Modal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                type="success"
                title="Produit ajouté au panier!"
                message={`${product.name} a été ajouté à votre panier.`}
                autoClose={true}
                autoCloseTime={3000}
                showCloseButton={true}
            />
        </>
    )
}

export default ProductCard;